import { render } from "./OptionsAndTermsAndCondition.vue?vue&type=template&id=4e1b4319"
import script from "./OptionsAndTermsAndCondition.vue?vue&type=script&lang=js"
export * from "./OptionsAndTermsAndCondition.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__